require("./jquery-simplemodal.js");
require("./modals.css");

var ensureIsDlg = function(url) {
    if (url.toLowerCase().indexOf("isdlg") === -1) {
        var prefix = url.indexOf("?") === -1 ? "?" : "&"
        url += prefix + "isDlg=1";
    }
    return url;
};
var promise = null;

var launch = exports.launch = function(url) {
    //clean up any existing modals by closing it and resolving with a CANCEL
    close();

    return new Promise((resolve, reject) => {
        promise = {resolve, reject};
        url = ensureIsDlg(url);
        var frameHeight = window.innerHeight - 60;
        frameHeight = frameHeight < 700 ? frameHeight : 700;
        var frameWidth = window.innerWidth - 60;
        frameWidth = frameWidth < 715 ? frameWidth : 715;
        jQuery.modal(`<iframe src="${url}" height="${frameHeight}" width="${frameWidth}" style="border:0">`, {
            containerCss:{
                backgroundColor:"#fff",
                borderColor:"#fff",
                padding:0,
                height: (frameHeight + 10),
                width: (frameWidth + 10)
            },
            closeHTML: '<a class="modalCloseImg" title="Close"></a>',
            overlayClose:true,
            escClose: true,
            modal: true,
            onClose: _close
        });
    })
};

var _close = function(e) {
    close({status: 0});
};

var close = exports.close = function(result) {
    if (promise) promise.resolve(result);
    jQuery.modal.close(); 
    promise = null;
};



// WEBPACK FOOTER //
// ./src/scripts/modals/index.js